import React from 'react';

export default function SVGLock(): JSX.Element {
  return (
    <svg
      width="23"
      height="24"
      viewBox="0 0 23 24"
      fill="none"
      className="text-iconStrong fill-current"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.5002 1C12.762 1 13.8361 1.4625 14.7226 2.3875C15.609 3.3125 16.0522 4.43333 16.0522 5.75V8.15H17.7293C18.1286 8.15 18.468 8.29583 18.7476 8.5875C19.0271 8.87917 19.1668 9.23333 19.1668 9.65V20.5C19.1668 20.9167 19.0271 21.2708 18.7476 21.5625C18.468 21.8542 18.1286 22 17.7293 22H5.271C4.87169 22 4.53228 21.8542 4.25277 21.5625C3.97325 21.2708 3.8335 20.9167 3.8335 20.5V9.65C3.8335 9.23333 3.97325 8.87917 4.25277 8.5875C4.53228 8.29583 4.87169 8.15 5.271 8.15H6.94808V5.75C6.94808 4.43333 7.39131 3.3125 8.27777 2.3875C9.16423 1.4625 10.2384 1 11.5002 1ZM11.5002 2.5C10.6377 2.5 9.90294 2.81667 9.296 3.45C8.68905 4.08333 8.38558 4.85 8.38558 5.75V8.15H14.6147V5.75C14.6147 4.85 14.3113 4.08333 13.7043 3.45C13.0974 2.81667 12.3627 2.5 11.5002 2.5ZM11.5002 13.15C10.9891 13.15 10.5538 13.3542 10.1944 13.7625C9.83506 14.1708 9.65537 14.625 9.65537 15.125C9.65537 15.6417 9.83506 16.0833 10.1944 16.45C10.5538 16.8167 10.9891 17 11.5002 17C12.0113 17 12.4465 16.8167 12.8059 16.45C13.1653 16.0833 13.345 15.6417 13.345 15.125C13.345 14.625 13.1653 14.1708 12.8059 13.7625C12.4465 13.3542 12.0113 13.15 11.5002 13.15Z" />
    </svg>
  );
}
